import {
  FONT_SIZE_INBETWEEN,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_LARGER,
  FONT_SIZE_LARGISH,
} from '~/Constants/UI.constants';
import { PRIMARY_BLUE, GRAY_USC, WHITE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventPageStyles = makeStyles((theme) => ({
  eventPageEditMenu: {
    position: 'absolute',
    zIndex: 100,
    top: -45,
    right: 15,
    [theme.breakpoints.up('md')]: {
      top: -68,
      right: 0,
    },
  },
  eventPageContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row-reverse',
    },
  },
  eventPageInformationSection: {
    [theme.breakpoints.up('md')]: {
      marginTop: 84,
      maxWidth: 220,
      minWidth: 220,
    },
  },
  eventPageBookingList: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
      marginRight: 60,
    },
  },
  content: {
    display: 'grid',
    gap: 24,
  },
  wrapper: {
    display: 'grid',
    gap: 16,
  },
  cancelReason: {
    height: '111px !important',
    padding: 16,
    background: WHITE,
    fontSize: FONT_SIZE_MEDIUM,
    letterSpacing: '0.5px',
    lineHeight: '27px',
    fontFamily: 'fitogram',
  },
  manageBookings: {
    marginRight: 31,
    fontSize: FONT_SIZE_INBETWEEN,
    letterSpacing: 0,
  },
  title: {
    fontSize: FONT_SIZE_LARGER,
    fontWeight: 'bold',
    lineHeight: '34px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  headerWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  integration: {
    marginLeft: 10,
    color: WHITE,
    fontSize: FONT_SIZE_INBETWEEN,
    fontWeight: 700,
    alignContent: 'center',
    [theme.breakpoints.up('md')]: {
      color: GRAY_USC,
    },
  },
  infoIcon: {
    color: PRIMARY_BLUE,
    fontSize: FONT_SIZE_LARGISH,
  },
}));
